export const JOB_SEARCH_PRICE_EUR = 39;
export const JOB_SEARCH_PERIOD_MONTHS = 3;
export const LIFETIME_PRICE_EUR = 149;
